import { styled } from '../../stitches.config'

const PseudoInput = styled('div', {
  all: 'unset',
  width: 'auto',
  padding: '$4',
  borderRadius: '$space$2',
  fontFamily: '$body',
  fontSize: 16,
  fontWeight: 400,
  color: '$neutralText',
  backgroundColor: '$inputBackground',
})

export default PseudoInput
